import { render, staticRenderFns } from "./Sip.vue?vue&type=template&id=4a6c5209&scoped=true&"
import script from "./Sip.vue?vue&type=script&lang=js&"
export * from "./Sip.vue?vue&type=script&lang=js&"
import style0 from "./Sip.vue?vue&type=style&index=0&id=4a6c5209&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c5209",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6c5209')) {
      api.createRecord('4a6c5209', component.options)
    } else {
      api.reload('4a6c5209', component.options)
    }
    module.hot.accept("./Sip.vue?vue&type=template&id=4a6c5209&scoped=true&", function () {
      api.rerender('4a6c5209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/control/Sip.vue"
export default component.exports